import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = {
  app_name: "نظام إدارة الجوازات",
  app_subtitle: "منصة رسمية للموظفين",
  logo_url: null,
  primary_color: "164 100% 18%",
  secondary_color: "46 65% 52%",
  pdf_default_header_title: "دائرة الجوازات",
  pdf_default_header_subtitle: "PASSPORT DEPARTMENT",
  pdf_footer_text: "تم إنشاء هذه الاستمارة إلكترونياً عبر نظام إدارة الجوازات",
};

function applyTheme(s) {
  const root = document.documentElement;
  if (s.primary_color) root.style.setProperty("--primary", s.primary_color);
  if (s.secondary_color) root.style.setProperty("--secondary", s.secondary_color);
  if (s.app_name) document.title = s.app_name;
}

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/system/settings");
      const merged = { ...DEFAULTS, ...data };
      setSettings(merged);
      applyTheme(merged);
    } catch {
      // not authenticated yet — fine
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const update = async (patch) => {
    const { data } = await api.put("/system/settings", patch);
    const merged = { ...DEFAULTS, ...data };
    setSettings(merged);
    applyTheme(merged);
    return merged;
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, refresh, update }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
